<template>
    <div class="source-list">
        <!-- 标题栏 -->
        <div class="source-header">
            <div class="title">待选列表</div>
            <div class="count">共 {{ images.length }} 张</div>
        </div>

        <!-- 操作提示 -->
        <div class="hint" v-if="images.length > 0">
            <small>点击添加到编辑列表</small>
        </div>

        <!-- 图片列表 -->
        <a-spin :spinning="loading" class="loading-wrapper">
            <div class="source-list-scroll">
                <ImageItem v-for="image in images" :key="image.requestId" :image="image"
                    :selected="isSelected(image.requestId)" :type="'source'" :size="'small'"
                    @click="handleClick(image)" />

                <!-- 空状态 -->
                <div v-if="images.length === 0" class="empty-state">
                    <img src="@/assets/logo.png" class="empty-logo" />
                    <p>暂无图片</p>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script setup>
import ImageItem from './ImageItem.vue';

const props = defineProps({
    images: {
        type: Array,
        required: true,
    },
    selectedIds: {
        type: Array,
        default: () => [],
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['add-to-edit']);

// 判断图片是否已被选中
const isSelected = (requestId) => {
    return props.selectedIds.includes(requestId);
};

// 处理点击事件
const handleClick = (image) => {
    console.log({ "source--image--list": props.images })
    if (!isSelected(image.requestId)) {
        emit('add-to-edit', image);
    }
};
</script>

<style lang="less" scoped>
.source-list {
    width: 100px;
    display: flex;
    flex-direction: column;
    // background: #f5f5f5;
    background: #ffffff;
    border-right: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.source-header {
    padding: 12px 8px;
    border-bottom: 1px solid #e0e0e0;
    background: #fff;

    .title {
        font-weight: 600;
        font-size: 13px;
        margin-bottom: 4px;
    }

    .count {
        font-size: 11px;
        color: #999;
    }
}

.hint {
    padding: 8px;
    text-align: center;
    color: #666;
    background: #fffbe6;
    border-bottom: 1px solid #ffe58f;

    small {
        font-size: 11px;
    }
}

.loading-wrapper {
    flex: 1;
    overflow: hidden;
    position: relative;
}

.source-list-scroll {
    height: 100%;
    overflow-y: auto;
    padding: 8px;
}

.empty-state {
    padding: 40px 20px;
    text-align: center;
    color: #999;

    .empty-logo {
        width: 40px;
        opacity: 0.3;
        margin-bottom: 12px;
    }

    p {
        font-size: 12px;
        margin: 0;
    }
}
</style>
